const removeAllActive = () => {
  const navLinks = document.getElementsByClassName("nav-link");
  console.log(navLinks.length);
  for (let i = 0; i < navLinks.length; i++) {
    navLinks[i].classList.remove("active");
  }
};

export const homeActive = () => {
  const homeLink = document.getElementById("home");

  removeAllActive();
  homeLink.classList.add("active");
  window.scrollBy(0, -window.scrollY);
};

export const aboutActive = () => {
  const aboutLink = document.getElementById("about");
  const home = document.getElementsByClassName("home")[0];
  removeAllActive();
  aboutLink.classList.add("active");
  window.scrollBy(0, -window.scrollY + home.offsetHeight + 20);
};

export const resumeActive = () => {
  const resumeLink = document.getElementById("resume");
  const about = document.getElementsByClassName("about")[0];
  const home = document.getElementsByClassName("home")[0];
  removeAllActive();
  resumeLink.classList.add("active");
  window.scrollBy(
    0,
    -window.scrollY + home.offsetHeight + about.offsetHeight + 20
  );
};

export const projectActive = () => {
  const projectLink = document.getElementById("project");
  const about = document.getElementsByClassName("about")[0];
  const home = document.getElementsByClassName("home")[0];
  const resume = document.getElementsByClassName("resume")[0];
  removeAllActive();
  projectLink.classList.add("active");
  window.scrollBy(
    0,
    -window.scrollY +
      home.offsetHeight +
      about.offsetHeight +
      resume.offsetHeight +
      20
  );
};

export const contactActive = () => {
  const contactLink = document.getElementById("contact");
  const about = document.getElementsByClassName("about")[0];
  const home = document.getElementsByClassName("home")[0];
  const resume = document.getElementsByClassName("resume")[0];
  const project = document.getElementsByClassName("projects")[0];

  removeAllActive();
  contactLink.classList.add("active");
  window.scrollBy(
    0,
    -window.scrollY +
      home.offsetHeight +
      about.offsetHeight +
      resume.offsetHeight +
      project.offsetHeight +
      20
  );
};
